export default __webpack_public_path__ + "13692501a7e405fcd8724a4fd4c69592.png";